import PropTypes from 'prop-types';

var MODAL_VARIANTS = ['headerless'];
var MODAL_CLOSE_BUTTON_THEMES = ['inverse'];
var modalProps = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  closeButtonLabel: PropTypes.string,
  closeButtonTheme: PropTypes.oneOf([''].concat(MODAL_CLOSE_BUTTON_THEMES)),
  footer: PropTypes.node,
  heading: PropTypes.node,
  isFullBleed: PropTypes.bool,
  isFullscreen: PropTypes.bool,
  isOpen: PropTypes.bool,
  isSticky: PropTypes.bool,
  onClose: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onOpen: PropTypes.func,
  variant: PropTypes.oneOf([''].concat(MODAL_VARIANTS))
};

export { MODAL_CLOSE_BUTTON_THEMES, MODAL_VARIANTS, modalProps as default };
//# sourceMappingURL=modalProps.js.map
